function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
export var JOSEError = /*#__PURE__*/function (_Error) {
  function JOSEError(message, options) {
    var _Error$captureStackTr;
    var _this;
    _classCallCheck(this, JOSEError);
    _this = _callSuper(this, JOSEError, [message, options]);
    _this.code = 'ERR_JOSE_GENERIC';
    _this.name = _this.constructor.name;
    (_Error$captureStackTr = Error.captureStackTrace) === null || _Error$captureStackTr === void 0 ? void 0 : _Error$captureStackTr.call(Error, _this, _this.constructor);
    return _this;
  }
  _inherits(JOSEError, _Error);
  return _createClass(JOSEError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
JOSEError.code = 'ERR_JOSE_GENERIC';
export var JWTClaimValidationFailed = /*#__PURE__*/function (_JOSEError) {
  function JWTClaimValidationFailed(message, payload) {
    var _this2;
    var claim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unspecified';
    var reason = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unspecified';
    _classCallCheck(this, JWTClaimValidationFailed);
    _this2 = _callSuper(this, JWTClaimValidationFailed, [message, {
      cause: {
        claim: claim,
        reason: reason,
        payload: payload
      }
    }]);
    _this2.code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
    _this2.claim = claim;
    _this2.reason = reason;
    _this2.payload = payload;
    return _this2;
  }
  _inherits(JWTClaimValidationFailed, _JOSEError);
  return _createClass(JWTClaimValidationFailed);
}(JOSEError);
JWTClaimValidationFailed.code = 'ERR_JWT_CLAIM_VALIDATION_FAILED';
export var JWTExpired = /*#__PURE__*/function (_JOSEError2) {
  function JWTExpired(message, payload) {
    var _this3;
    var claim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unspecified';
    var reason = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unspecified';
    _classCallCheck(this, JWTExpired);
    _this3 = _callSuper(this, JWTExpired, [message, {
      cause: {
        claim: claim,
        reason: reason,
        payload: payload
      }
    }]);
    _this3.code = 'ERR_JWT_EXPIRED';
    _this3.claim = claim;
    _this3.reason = reason;
    _this3.payload = payload;
    return _this3;
  }
  _inherits(JWTExpired, _JOSEError2);
  return _createClass(JWTExpired);
}(JOSEError);
JWTExpired.code = 'ERR_JWT_EXPIRED';
export var JOSEAlgNotAllowed = /*#__PURE__*/function (_JOSEError3) {
  function JOSEAlgNotAllowed() {
    var _this4;
    _classCallCheck(this, JOSEAlgNotAllowed);
    _this4 = _callSuper(this, JOSEAlgNotAllowed, arguments);
    _this4.code = 'ERR_JOSE_ALG_NOT_ALLOWED';
    return _this4;
  }
  _inherits(JOSEAlgNotAllowed, _JOSEError3);
  return _createClass(JOSEAlgNotAllowed);
}(JOSEError);
JOSEAlgNotAllowed.code = 'ERR_JOSE_ALG_NOT_ALLOWED';
export var JOSENotSupported = /*#__PURE__*/function (_JOSEError4) {
  function JOSENotSupported() {
    var _this5;
    _classCallCheck(this, JOSENotSupported);
    _this5 = _callSuper(this, JOSENotSupported, arguments);
    _this5.code = 'ERR_JOSE_NOT_SUPPORTED';
    return _this5;
  }
  _inherits(JOSENotSupported, _JOSEError4);
  return _createClass(JOSENotSupported);
}(JOSEError);
JOSENotSupported.code = 'ERR_JOSE_NOT_SUPPORTED';
export var JWEDecryptionFailed = /*#__PURE__*/function (_JOSEError5) {
  function JWEDecryptionFailed() {
    var _this6;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'decryption operation failed';
    var options = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, JWEDecryptionFailed);
    _this6 = _callSuper(this, JWEDecryptionFailed, [message, options]);
    _this6.code = 'ERR_JWE_DECRYPTION_FAILED';
    return _this6;
  }
  _inherits(JWEDecryptionFailed, _JOSEError5);
  return _createClass(JWEDecryptionFailed);
}(JOSEError);
JWEDecryptionFailed.code = 'ERR_JWE_DECRYPTION_FAILED';
export var JWEInvalid = /*#__PURE__*/function (_JOSEError6) {
  function JWEInvalid() {
    var _this7;
    _classCallCheck(this, JWEInvalid);
    _this7 = _callSuper(this, JWEInvalid, arguments);
    _this7.code = 'ERR_JWE_INVALID';
    return _this7;
  }
  _inherits(JWEInvalid, _JOSEError6);
  return _createClass(JWEInvalid);
}(JOSEError);
JWEInvalid.code = 'ERR_JWE_INVALID';
export var JWSInvalid = /*#__PURE__*/function (_JOSEError7) {
  function JWSInvalid() {
    var _this8;
    _classCallCheck(this, JWSInvalid);
    _this8 = _callSuper(this, JWSInvalid, arguments);
    _this8.code = 'ERR_JWS_INVALID';
    return _this8;
  }
  _inherits(JWSInvalid, _JOSEError7);
  return _createClass(JWSInvalid);
}(JOSEError);
JWSInvalid.code = 'ERR_JWS_INVALID';
export var JWTInvalid = /*#__PURE__*/function (_JOSEError8) {
  function JWTInvalid() {
    var _this9;
    _classCallCheck(this, JWTInvalid);
    _this9 = _callSuper(this, JWTInvalid, arguments);
    _this9.code = 'ERR_JWT_INVALID';
    return _this9;
  }
  _inherits(JWTInvalid, _JOSEError8);
  return _createClass(JWTInvalid);
}(JOSEError);
JWTInvalid.code = 'ERR_JWT_INVALID';
export var JWKInvalid = /*#__PURE__*/function (_JOSEError9) {
  function JWKInvalid() {
    var _this0;
    _classCallCheck(this, JWKInvalid);
    _this0 = _callSuper(this, JWKInvalid, arguments);
    _this0.code = 'ERR_JWK_INVALID';
    return _this0;
  }
  _inherits(JWKInvalid, _JOSEError9);
  return _createClass(JWKInvalid);
}(JOSEError);
JWKInvalid.code = 'ERR_JWK_INVALID';
export var JWKSInvalid = /*#__PURE__*/function (_JOSEError0) {
  function JWKSInvalid() {
    var _this1;
    _classCallCheck(this, JWKSInvalid);
    _this1 = _callSuper(this, JWKSInvalid, arguments);
    _this1.code = 'ERR_JWKS_INVALID';
    return _this1;
  }
  _inherits(JWKSInvalid, _JOSEError0);
  return _createClass(JWKSInvalid);
}(JOSEError);
JWKSInvalid.code = 'ERR_JWKS_INVALID';
export var JWKSNoMatchingKey = /*#__PURE__*/function (_JOSEError1) {
  function JWKSNoMatchingKey() {
    var _this10;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'no applicable key found in the JSON Web Key Set';
    var options = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, JWKSNoMatchingKey);
    _this10 = _callSuper(this, JWKSNoMatchingKey, [message, options]);
    _this10.code = 'ERR_JWKS_NO_MATCHING_KEY';
    return _this10;
  }
  _inherits(JWKSNoMatchingKey, _JOSEError1);
  return _createClass(JWKSNoMatchingKey);
}(JOSEError);
JWKSNoMatchingKey.code = 'ERR_JWKS_NO_MATCHING_KEY';
export var JWKSMultipleMatchingKeys = /*#__PURE__*/function (_JOSEError10) {
  function JWKSMultipleMatchingKeys() {
    var _this11;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'multiple matching keys found in the JSON Web Key Set';
    var options = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, JWKSMultipleMatchingKeys);
    _this11 = _callSuper(this, JWKSMultipleMatchingKeys, [message, options]);
    _this11.code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
    return _this11;
  }
  _inherits(JWKSMultipleMatchingKeys, _JOSEError10);
  return _createClass(JWKSMultipleMatchingKeys);
}(JOSEError);
Symbol.asyncIterator;
JWKSMultipleMatchingKeys.code = 'ERR_JWKS_MULTIPLE_MATCHING_KEYS';
export var JWKSTimeout = /*#__PURE__*/function (_JOSEError11) {
  function JWKSTimeout() {
    var _this12;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'request timed out';
    var options = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, JWKSTimeout);
    _this12 = _callSuper(this, JWKSTimeout, [message, options]);
    _this12.code = 'ERR_JWKS_TIMEOUT';
    return _this12;
  }
  _inherits(JWKSTimeout, _JOSEError11);
  return _createClass(JWKSTimeout);
}(JOSEError);
JWKSTimeout.code = 'ERR_JWKS_TIMEOUT';
export var JWSSignatureVerificationFailed = /*#__PURE__*/function (_JOSEError12) {
  function JWSSignatureVerificationFailed() {
    var _this13;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'signature verification failed';
    var options = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, JWSSignatureVerificationFailed);
    _this13 = _callSuper(this, JWSSignatureVerificationFailed, [message, options]);
    _this13.code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';
    return _this13;
  }
  _inherits(JWSSignatureVerificationFailed, _JOSEError12);
  return _createClass(JWSSignatureVerificationFailed);
}(JOSEError);
JWSSignatureVerificationFailed.code = 'ERR_JWS_SIGNATURE_VERIFICATION_FAILED';